import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { updateSelectedComponentAction } from '../../../actions/instances/components';
import { updateSelectedElementAction } from '../../../actions/instances/elements';
import { updateSelectedContextAction } from '../../../actions/instances/context';
import { updateSelectedProductAction } from '../../../actions/instances/products';
import { updateSelectedCharacteristicAction } from '../../../actions/instances/characteristics';
import { updateSelectedUserAction } from '../../../actions/usersActions';
import { setSelectedBuildingAction } from '../../../actions/instances/buildings';
import SearchBlock from '../../Organisms/SearchBlock/SearchBlock';
import Navbar from '../../Organisms/Navbar/Navbar';
import Footer from '../../Organisms/Footer/Footer';
import './KnowledgeBase.scss';
import FullPageLoader from '../../atoms/FullPageLoader/FullPageLoader';

const pathsToResetIn = [
  '/buildings',
  '/instances/building-components',
  '/instances/building-elements',
  '/instances/building-products',
  '/instances/building-contexts',
  '/instances/building-characteristics',
];

const KnowledgeBase = ({
  children,
}) => {
  const location = useLocation();
  const { isAppLoading } = useSelector(state => state.app);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    history.listen((loc) => {
      if (pathsToResetIn.includes(loc.pathname)) {
        dispatch(updateSelectedUserAction(undefined));
        dispatch(updateSelectedComponentAction(undefined));
        dispatch(updateSelectedContextAction(undefined));
        dispatch(updateSelectedElementAction(undefined));
        dispatch(updateSelectedProductAction(undefined));
        dispatch(updateSelectedCharacteristicAction(undefined));
        dispatch(setSelectedBuildingAction(undefined));
      }
      window.scrollTo(0, 0);
    });
  }, []);
  if (isAppLoading) {
    return <FullPageLoader />;
  }
  return (
    <>
      <Navbar />
      {location.pathname === '/home' && (
        <SearchBlock />
      )}
      <div className="page-container">
        <div className="container">
          {children}
        </div>
      </div>
      <Footer />
    </>
  );
};

KnowledgeBase.propTypes = {
  children: PropTypes.node.isRequired,
};

export default KnowledgeBase;
